module.exports = __webpack_public_path__ + "img/p2-50.84afe5da.png";